// @mui
import { Card, Stack, Typography } from '@mui/material';
// utils
import useLocales from '../../../hooks/useLocales';

// ----------------------------------------------------------------------
export default function QuestionInfo() {
  const { translate } = useLocales();

  return (
    <Card>
      <Stack spacing={2} sx={{ px: 3, py: 2 }}>
        <Typography variant="body2">{translate("question.description")}</Typography>
      </Stack>
    </Card>
  );
}